import { useTranslations } from 'next-intl';

import type { TranslateFunction } from '@/types/general';
import { getFlagUrl, getLanguageDisplay } from '@/utils/language-helpers';

import { Image } from '../ui/image';

type FlagByLanguageProps = {
  code: string;
  showLabel?: boolean;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  rounded?: boolean;
};

const FlagByLanguage: React.FC<FlagByLanguageProps> = ({
  code,
  showLabel = true,
  className = '',
  size = 'md',
  rounded = false,
}) => {
  const translate = useTranslations();

  if (code === undefined || code === null || code === '') {
    return null;
  }

  const sizeClasses = {
    sm: {
      container: 'max-w-[14px] max-h-[14px]',
      image: 'w-[14px] h-[14px]',
      dimensions: 14,
    },
    md: {
      container: 'max-w-[20px] max-h-[20px]',
      image: 'w-[20px] h-[20px]',
      dimensions: 20,
    },
    lg: {
      container: 'max-w-[24px] max-h-[24px]',
      image: 'w-[24px] h-[24px]',
      dimensions: 24,
    },
  };

  const currentSize = sizeClasses[size];

  const containerClasses = rounded
    ? `${currentSize.container} rounded-full overflow-hidden`
    : `${currentSize.container} rounded-sm`;

  const imageClasses = rounded
    ? `${currentSize.image} rounded-full object-cover`
    : `${currentSize.image} rounded-sm`;

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className={containerClasses}>
        <Image
          src={getFlagUrl(code)}
          alt={getLanguageDisplay(code, translate as TranslateFunction)}
          width={currentSize.dimensions}
          height={currentSize.dimensions}
          className={imageClasses}
        />
      </div>
      {showLabel && (
        <span className="truncate">
          {getLanguageDisplay(code, translate as TranslateFunction)}
        </span>
      )}
    </div>
  );
};

export default FlagByLanguage;
